import path from '@/api/index'
import {
  axios
} from '@/utils/request'
import parsePageParams from '@/utils/page'

const prefix = '/my/idea'
// 分页
export function queryList (data) {
  return axios({
    url: path.client + prefix,
    method: 'POST',
    data: data,
    params: parsePageParams(data)
  })
}

// 获取详情
export function get (id) {
  return axios({
    url: path.client + prefix + '/id/' + id,
    method: 'GET'
  })
}

// 保存
export function save (data) {
  return axios({
    url: path.client + prefix +'/add',
    method: 'PUT',
    data: data
  })
}
